import { useLocation, useNavigate } from 'react-router-dom';
import { footerLinks } from '@/mocks/homeData';
import { getSiteConfig } from '@/utils/siteConfigStore';

export default function Footer() {
  const location = useLocation();
  const navigate = useNavigate();
  const siteConfig = getSiteConfig();

  const handleNavClick = (path: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    if (location.pathname === path) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate(path);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-brand-deep text-white">
      <div className="px-6 md:px-10 py-14 md:py-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">
            <div className="lg:col-span-4">
              <a href="/" onClick={handleNavClick('/')} className="inline-block mb-4 cursor-pointer">
                <img
                  src={siteConfig.logoUrl}
                  alt="麦杰集团"
                  className="h-9 md:h-10 w-auto object-contain brightness-0 invert"
                />
              </a>
              <p className="text-white/50 text-sm leading-relaxed mb-6 max-w-xs">
                麦杰集团旗下专业减肥纤体连锁品牌，十余年行业积淀，致力于为每一位顾客提供绿色、高效、个性化的健康体重管理服务。
              </p>
            </div>

            <div className="lg:col-span-2">
              <h3 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-5">品牌导航</h3>
              <ul className="flex flex-col gap-3">
                {footerLinks.brand.map((link) => (
                  <li key={link.label}>
                    <a href={link.path} onClick={handleNavClick(link.path)} className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="lg:col-span-2">
              <h3 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-5">服务与门店</h3>
              <ul className="flex flex-col gap-3">
                {footerLinks.solutions.map((link) => (
                  <li key={link.label}>
                    <a href={link.path} onClick={handleNavClick(link.path)} className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="lg:col-span-2">
              <h3 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-5">招商加盟</h3>
              <ul className="flex flex-col gap-3">
                {footerLinks.franchise.map((link) => (
                  <li key={link.label}>
                    <a href={link.path} onClick={handleNavClick(link.path)} className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="lg:col-span-2">
              <h3 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-5">关注我们</h3>
              <div className="flex gap-4">
                <div className="flex-1 text-center">
                  <div className="w-24 h-24 md:w-28 md:h-28 mx-auto bg-white rounded-xl overflow-hidden p-1">
                    <img
                      src={siteConfig.footerQrWechat}
                      alt="微信公众号"
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <p className="text-[10px] text-white/40 mt-2">微信公众号</p>
                </div>
                <div className="flex-1 text-center">
                  <div className="w-24 h-24 md:w-28 md:h-28 mx-auto bg-white rounded-xl overflow-hidden p-1">
                    <img
                      src={siteConfig.footerQrTiktok}
                      alt="抖音"
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <p className="text-[10px] text-white/40 mt-2">抖音</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="px-6 md:px-10 py-6">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-white/30">
              &copy; {new Date().getFullYear()} 麦杰集团 版权所有
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-white/30 hover:text-white/50 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-white/30 hover:text-white/50 transition-colors cursor-pointer">服务条款</a>
              <a href="#" className="text-xs text-white/30 hover:text-white/50 transition-colors cursor-pointer">网站地图</a>
              <a href="/admin" target="_blank" rel="noopener noreferrer" className="text-xs text-white/30 hover:text-white/50 transition-colors cursor-pointer">内容管理</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}